
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SidebarLayout } from "./layout/SidebarLayout";
import { AuthGate } from "./components/AuthGate";

// Overview Pages
import { Home } from "./pages/Home";
import { Dashboard } from "./pages/Dashboard";
import { Pricing } from "./pages/Pricing";
import { UserProfile } from "./pages/UserProfileData"

// Internal Intelligence Pages
import { TeamHub } from "./pages/internal/TeamHub";
import { PlayerStats } from "./pages/internal/PlayerStats";
import { FocusAreas } from "./pages/internal/FocusAreas";
import { TeamNotes } from "./pages/internal/TeamNotes";

// External Intelligence Pages
import { OpponentScouting } from "./pages/external/OpponentScouting";
import { UpcomingMatches } from "./pages/external/UpcomingMatches";
import { TeamProfile } from "./pages/external/TeamProfile"; // /team/:id
import { MatchPrepNotes } from "./pages/external/MatchPrepNotes";

// FACEIT API Playground Pages
import { PlayerById } from "./pages/faceit/PlayerById";
import { SearchPlayers } from "./pages/faceit/SearchPlayers";
import { TeamById } from "./pages/faceit/TeamById";
import { MatchById } from "./pages/faceit/MatchById";
import { MatchStats } from "./pages/faceit/MatchStats";
import { Championships } from "./pages/faceit/Championships";
import { OpponentIntelligence } from "./pages/faceit/OpponentIntelligence";


export default function App() {
  return (
    <Router>
      <AuthGate>
        <SidebarLayout>
          <Routes>
          {/* OVERVIEW */}
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/profile" element={<UserProfile />} />

          {/* INTERNAL INTELLIGENCE */}
          <Route path="/team-hub" element={<TeamHub />} />
          <Route path="/stats" element={<PlayerStats />} />
          <Route path="/focus" element={<FocusAreas />} />
          <Route path="/team-notes" element={<TeamNotes />} />

          {/* EXTERNAL INTELLIGENCE */}
          <Route path="/opponent-scouting" element={<OpponentScouting />} />
          <Route path="/upcoming-matches" element={<UpcomingMatches />} />
          <Route path="/team/:id" element={<TeamProfile />} />
          <Route path="/match-prep-notes" element={<MatchPrepNotes />} />

          {/* FACEIT API PLAYGROUND */}
          <Route path="/faceit/player" element={<PlayerById />} />
          <Route path="/faceit/search" element={<SearchPlayers />} />
          <Route path="/faceit/team" element={<TeamById />} />
          <Route path="/faceit/match" element={<MatchById />} />
          <Route path="/faceit/match-stats" element={<MatchStats />} />
          <Route path="/faceit/championships" element={<Championships />} />
          <Route path="/faceit/intel" element={<OpponentIntelligence />} />
          <Route path="/faceit/intel/:teamId" element={<OpponentIntelligence />} />
          </Routes>
        </SidebarLayout>
      </AuthGate>
    </Router>
  );
}
